import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Table } from "../../utils/PMTable/Table";
import { TableBody } from "../../utils/PMTable/TableBody";
import { PMPagination } from "../../utils/PMPagination";
import { useNavigate } from "react-router-dom";
import {
  DeliveryAddressTitle,
  LoadingRows,
  SyncStatus,
  ItemStatus,
} from "../../Utils";
import { ResourceEmpty } from "../../utils/ResourceEmpty";
import { TripletexSyncBadge } from "../tripletex/tripletex-sync-badge";
import { PMDataTable } from "../../utils/PMTableView/PMDataTable";
import { CellLink } from "../../utils/PMTableView/CellLink";

const people = [
  {
    name: "Lindsay Walton",
    title: "Front-end Developer",
    email: "lindsay.walton@example.com",
    role: "Member",
  },
  // More people...
];

export const CustomersTable = ({
  page = 1,
  itemState = [],
  itemsCount = 0,
  selectedItems = [],
  sort = "desc",
  sortBy = "createdAt",
  ...props
}) => {
  const { onPageChange, perPage, currentCount } =
    props;
  const { data, isLoading, errors } = itemState;

  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedPeople, setSelectedPeople] = useState([]);

  useLayoutEffect(() => {
    const isIndeterminate =
      selectedPeople.length > 0 && selectedPeople.length < people.length;
    setChecked(selectedPeople.length === people.length);
    setIndeterminate(isIndeterminate);
    // checkbox.current.indeterminate = isIndeterminate
  }, [selectedPeople]);

  function toggleAll() {
    setSelectedPeople(checked || indeterminate ? [] : people);
    setChecked(!checked && !indeterminate);
    setIndeterminate(false);
  }

  const navigate = useNavigate();

  function renderRows() {
    return data?.map((item, index) => {
      return (
        <tr
          key={item.id}
          onClick={() => navigate("/dashboard/customers/" + item.id)}
        >
          <td></td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
            <div className="flex items-center">
              <div className="ml-4">
                <div className="font-medium text-gray-900">{item.name}</div>
                <div className="text-gray-500">{item.customer_number}</div>
              </div>
            </div>
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            <div className="text-gray-900">Mobile: {item.mobile}</div>
            <div className="text-gray-500">Email: {item.email}</div>
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {DeliveryAddressTitle({ deliveryAddress: item?.postal_address })}
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm">
            <div className="flex flex-col items-start gap-1">
            {item?.active ? (
              <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                Active
              </span>
            ) : (
              <span className="inline-flex items-center rounded-full bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-800">
                Inactive
              </span>
            )}
            {item?.profile_locked && (
              <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
                Låst
              </span>
            )}
            </div>
          </td>
          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
            <div className="ml-2 flex justify-end">
              {item?.tripletex_sync?.enabled ? (
                <TripletexSyncBadge sync={item?.tripletex_sync} />
              ) : (
                <SyncStatus item={item} />
              )}
            </div>
          </td>
        </tr>
      );
    });
  }

  return (
    <>
      <Table>
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
            ></th>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
            >
              Title
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Contact info
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Address
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Status
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <TableBody>
          {isLoading ? (
            <>
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
              <LoadingRows cols={5} checkboxCell={true} />
            </>
          ) : data?.length < 1 ? (
            <tr>
              <td colSpan={7} className="py-2 px-2">
                <ResourceEmpty />
              </td>
            </tr>
          ) : (
            renderRows()
          )}
        </TableBody>
      </Table>

      <PMPagination
        disabled={isLoading}
        onPageChange={onPageChange}
        page={page}
        perPage={perPage}
        rowsCount={itemsCount}
        totalCount={itemsCount}
        currentCount={currentCount}
        showCount={true}
      />
    </>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// New Promang Table View (schema-driven) implementation for the customer list.
// ─────────────────────────────────────────────────────────────────────────────

const customerSync = (item) =>
  item?.tripletex_sync?.enabled ? (
    <TripletexSyncBadge sync={item?.tripletex_sync} />
  ) : (
    <SyncStatus item={item} />
  );

// Full column definitions (with cell renderers + grouping). Exported so the
// list page can derive column metadata for the toolbar / useTableView hook.
export const getCustomerColumns = (t) => [
  {
    key: "customer_number",
    label: t("Number"),
    sortKey: "customer_number",
    width: 120,
    always: true,
    cell: (item) => (
      <CellLink
        to={item?.id ? `/dashboard/customers/${item.id}` : null}
        className="text-[13.5px] font-semibold tabular-nums text-blue-600"
      >
        {item.customer_number || "—"}
      </CellLink>
    ),
  },
  {
    key: "name",
    label: t("Name"),
    sortKey: "name",
    width: 240,
    always: true,
    cell: (item) => (
      <CellLink
        to={item?.id ? `/dashboard/customers/${item.id}` : null}
        className="block max-w-[240px] truncate text-[13.5px] font-medium text-slate-800"
      >
        {item.name || item.displayTitle || "—"}
      </CellLink>
    ),
  },
  {
    key: "contact",
    label: t("Contact info"),
    width: 220,
    cell: (item) => (
      <div className="flex min-w-0 flex-col gap-0.5">
        {item.email && (
          <span className="truncate text-[13px] text-slate-600">{item.email}</span>
        )}
        {item.mobile && (
          <span className="truncate text-[12px] text-slate-400">{item.mobile}</span>
        )}
        {!item.email && !item.mobile && <span className="text-slate-300">—</span>}
      </div>
    ),
  },
  {
    key: "address",
    label: t("Address"),
    width: 220,
    defaultVisible: false,
    cell: (item) => (
      <span className="block max-w-[220px] truncate text-[13px] text-slate-500">
        {DeliveryAddressTitle({ deliveryAddress: item?.postal_address }) || "—"}
      </span>
    ),
  },
  {
    key: "active",
    label: t("Status"),
    sortKey: "active",
    width: 110,
    stopRowClick: true,
    groupable: true,
    groupValue: (item) => (item.active ? "active" : "inactive"),
    groupLabel: (key) => (key === "inactive" ? t("Inactive") : t("Active")),
    cell: (item) => <ItemStatus item={item} />,
  },
  {
    key: "sync",
    label: t("Sync"),
    width: 120,
    stopRowClick: true,
    cell: (item) => <div className="flex">{customerSync(item)}</div>,
  },
];

export const CustomersDataTable = ({
  itemState = { data: [], isLoading: false },
  columns,
  visibleKeys,
  widths,
  onResize,
  groupBy = "none",
  sort = null,
  onSort,
  density = "comfortable",
  hasMore = false,
  onLoadMore,
  onItemsSelect,
  onRowClick,
}) => {
  const { data = [], isLoading } = itemState;
  return (
    <PMDataTable
      columns={columns}
      visibleKeys={visibleKeys}
      widths={widths}
      onResize={onResize}
      groupBy={groupBy}
      sort={sort}
      onSort={onSort}
      data={data}
      isLoading={isLoading}
      density={density}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      onSelectionChange={onItemsSelect}
      onRowClick={onRowClick}
      mobileRowLayout
    />
  );
};

CustomersDataTable.defaultProps = {
  itemState: { data: [], isLoading: false },
  density: "comfortable",
  hasMore: false,
};
